import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
export function BonusSection() {
  return <section className="border-y border-gold/20 bg-white px-4 py-20 sm:py-28" data-id="element-19" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="1aogt27k3ds8m">
        <div className="text-center" data-id="element-21" data-mp="1apift9ah0366">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-22" data-mp="1amct20pbdddm">
            Your 6-in-1 system doesn’t stop there
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-ink sm:text-4xl" data-id="element-23" data-mp="1jhsrkv10kgpj">
            5 professional bonus guides{' '}
            <span className="italic text-burgundy" data-id="element-24" data-mp="1eohkcssahxx3">at no additional cost</span>
          </h2>
          <Ornament className="mt-5" data-id="element-25" data-mp="qz597ndejfs5" />
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-ink-muted" data-id="element-26" data-mp="qy3r4yxyxt0x">
            Along with the complete six-volume teaching system, you also
            receive:
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="2er66cvoplphk">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col overflow-hidden rounded-xl border border-gold/40 bg-beige/70 shadow-soft ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-28" data-mp="2jhcvqxr1pe0v" data-mpi={index}>
              <div className="flex items-center justify-between gap-3 border-b border-gold/30 px-6 py-4" data-id="element-29" data-mp="25s2lbm5zf00f">
                <span className="font-display text-2xl font-semibold text-burgundy" data-id="element-30" data-mp="3c6aef1z65cu5">
                  BONUS {bonus.id}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/60 text-gold" data-id="element-31" data-mp="1h2vu908mbz4t">
                  <GiftIcon size={18} strokeWidth={1.5} aria-hidden="true" data-id="element-32" data-mp="1c396hwv5z0hr" />
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-33" data-mp="1q3jy524asj3z">
                <h3 className="text-xl font-semibold leading-snug text-burgundy" data-id="element-34" data-mp="1m1ypjsysqqzl">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm font-semibold leading-6 text-ink" data-id="element-35" data-mp="ydp4wudbk9a1">
                  {bonus.tagline}
                </p>
                {bonus.intro.map(paragraph => <p key={paragraph} className="mt-3 text-sm leading-6 text-ink-muted" data-id="element-36" data-mp="176990acdr629">
                    {paragraph}
                  </p>)}
                <p className="mt-4 text-sm font-semibold text-ink" data-id="element-37" data-mp="endi1mzohlzh">
                  {bonus.listLabel}
                </p>
                <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-38" data-mp="al8mgipo6fa7">
                  {bonus.bullets.map(bullet => <li key={bullet} className="rounded-full border border-gold/30 bg-cream px-2.5 py-1 text-xs font-medium text-ink" data-id="element-39" data-mp="5a4m99yw5un0">
                      {bullet}
                    </li>)}
                </ul>
                {bonus.flow && <FlowLine className="mt-5" label={bonus.flow.label} steps={bonus.flow.steps} data-id="element-40" data-mp="j9mc7snxbdxy" />}
                {bonus.closing && <p className="mt-4 text-sm font-medium leading-6 text-ink" data-id="element-41" data-mp="9bgezod2avzf">
                    {bonus.closing}
                  </p>}
                <p className="mt-auto pt-6" data-id="element-42" data-mp="2u1finln2qiw8">
                  <span className="inline-flex rounded-md border border-gold/50 bg-cream px-3 py-1.5 text-xs font-bold uppercase tracking-[0.08em] text-burgundy" data-id="element-43" data-mp="2u0m96cwqdfae">
                    Included at no additional cost
                  </span>
                </p>
              </div>
            </motion.article>)}
        </div>
        <CountdownTimer data-id="element-44" data-mp="35id585x0zcft" />
      </div>
    </section>;
}